module.exports = __webpack_public_path__ + "static/media/400339_02.3cd3e967.png";